import axios from 'axios';

const API_BASE_URL = '/api';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  getProfile: () => api.get('/auth/me'),
  updateProfile: (userData) => api.put('/auth/profile', userData),
};

//Product API
export const productsAPI = {
  getAll: (params = {}) => api.get('/products', { params }),
  getById: (id) => api.get(`/products/${id}`),
  create: (productData) => {
    console.log('Sending to API:', productData); // Add this
    return api.post('/products', productData, {
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}` // Ensure auth header
      }
    });
  },
  update: (id, productData) => {
    return api.put(`/products/${id}`, productData, {
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
  },
  delete: (id) => api.delete(`/products/${id}`),
  getStats: () => api.get('/products/stats/summary'),
};

// dELIVERY Challan API 
export const deliveryAPI = {
  getAll: (params = {}) => api.get('/delivery', { params }),
  getById: (id) => api.get(`/delivery/${id}`),
  create: (challanData) => {
    console.log('Sending delivery data:', challanData);
    return api.post('/delivery', challanData, {
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
  },
  update: (id, challanData) => {
    return api.put(`/delivery/${id}`, challanData, {
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
  },
  delete: (id) => api.delete(`/delivery/${id}`),
  updateStatus: (id, statusData) => api.patch(`/delivery/${id}/status`, statusData),
  print: (id) => api.get(`/delivery/print/${id}`, { responseType: 'blob' })
};

// Users API
export const userAPI = {
  getAll: (params = {}) => api.get('/users', { params }),
  getById: (id) => api.get(`/users/${id}`),
  create: (userData) => api.post('/users', userData),
  update: (id, userData) => api.put(`/users/${id}`, userData),
  delete: (id) => api.delete(`/users/${id}`),
  updateStatus: (id, statusData) => api.patch(`/users/${id}/status`, statusData),
};

export default api;